import {
  InputLabel,
  FormGroup,
  FormControl,
  Button,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import header2 from "../header2.png";
import footer2 from "../footer2.PNG";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
  },
  column2: {
    marginLeft: 10,
    width: 200,
  },
  column7: {
    align: "center",
  },
  column4: {
    marginLeft: 10,
    width: 200,
    color: "red",
  },
  para: {
    marginLeft: 50,
    marginTop: 50,
  },
  daypara: {
    marginLeft: 50,
  },
  daypara2: {
    marginLeft: 50,
    width: 690,
  },
  tablepara: {
    marginLeft: 5,
    marginTop: 5,
    width: 690,
  },
  tablepara2: {
    marginLeft: 0,
    marginTop: 5,
    width: 690,
  },
  column: {
    marginLeft: 50,
    width: 325,
  },
  column3: {
    marginLeft: 10,
    width: 325,
  },
  column6: {
    marginLeft: 0,
    width: 325,
  },
  column5: {
    marginLeft: 10,
    width: 600,
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(15),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  div: {
    backgroundColor: "#f5f5f5",
    width: "210mm",
    minHeight: "297mm",
    marginLeft: "auto",
    marginRight: "auto",
  },
  texttypo: {
    color: "black",
    lineHeight: "75%",
  },
  texttypo2: {
    color: "#a8020b",
    verticalAlign: "middle",
    marginLeft: theme.spacing(4),
    fontStyle: "italic",
  },
  texttypo3: {
    color: "#4f1802",
    marginLeft: 50,
    marginTop: 50,
  },
  divider1: {
    color: "#a8020b",
    width: "80px",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
}));

const Viewvoucher = () => {
  const classes = useStyles();
  var x = 0;
  var pagecount = 1;
  //image pasting
  window.addEventListener("paste", (e) => {
    if (x && e.clipboardData.files.length > 0) {
      // var x=0
      // document.getElementById("#myfile")==null?x=1:x=0
      // document.getElementById("#myfile2")==null?x=2:x=0
      // document.getElementById("#myfile3")==null?x=3:x=0
      console.log(x);
      // const fileInput=document.querySelector("#myfile")
      // fileInput.files=e.clipboardData.files

      if (e.clipboardData.files[0].type.startsWith("image/")) {
        setPreviewImage(e.clipboardData.files[0]);
      }
    }
  });

  function setPreviewImage(file) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      if (x == 1) {
        document.querySelector("#imagePreview").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview").src)
      } else if (x == 2) {
        document.querySelector("#imagePreview2").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview2").src)
      } else if (x == 3) {
        document.querySelector("#imagePreview3").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      } else if (x == 4) {
        document.querySelector("#imagePreview4").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      } else if (x == 5) {
        document.querySelector("#imagePreview5").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
      else if (x == 6) {
        document.querySelector("#imagePreview6").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
      else if (x == 7) {
        document.querySelector("#imagePreview7").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
      else if (x == 8) {
        document.querySelector("#imagePreview8").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
      else if (x == 9) {
        document.querySelector("#imagePreview9").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
      else if (x == 10) {
        document.querySelector("#imagePreview10").src = fileReader.result;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
    };
  }
  const removeimage = (e) => {
    //console.log(e.target.innerHTML)

    if (e.target.innerHTML == "Remove Image 1") {
      document.querySelector("#imagePreview").src = "abc";

      x = 0;
    } else if (e.target.innerHTML == "Remove Image 2") {
      document.querySelector("#imagePreview2").src = "abc";

      x = 0;
    } else if (e.target.innerHTML == "Remove Image 3") {
      document.querySelector("#imagePreview3").src = "abc";

      x = 0;
    } else if (e.target.innerHTML == "Remove Image 4") {
      document.querySelector("#imagePreview4").src = "abc";

      x = 0;
    } else if (e.target.innerHTML == "Remove Image 5") {
      document.querySelector("#imagePreview5").src = "abc";

      x = 0;
    }else if (e.target.innerHTML == "Remove Image 6") {
      document.querySelector("#imagePreview6").src = "abc";

      x = 0;
    }else if (e.target.innerHTML == "Remove Image 7") {
      document.querySelector("#imagePreview7").src = "abc";

      x = 0;
    }else if (e.target.innerHTML == "Remove Image 8") {
      document.querySelector("#imagePreview8").src = "abc";

      x = 0;
    }else if (e.target.innerHTML == "Remove Image 9") {
      document.querySelector("#imagePreview9").src = "abc";

      x = 0;
    }else if (e.target.innerHTML == "Remove Image 10") {
      document.querySelector("#imagePreview10").src = "abc";

      x = 0;
  };
  }

  const savepdf = () => {
    var imgdata = [];
    let pdf = new jsPDF();
    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
        const imgdata1 = document.getElementById("image1");
        html2canvas(imgdata1).then((canvas) => {
          imgdata[0] = canvas.toDataURL("image/jpeg", 0.5);
          const imgdata2 = document.getElementById("imagePreview2");
          html2canvas(imgdata2).then((canvas) => {
            imgdata[1] = canvas.toDataURL("image/jpeg", 0.5);
            const imgdata3 = document.getElementById("imagePreview3");
            html2canvas(imgdata3).then((canvas) => {
              imgdata[2] = canvas.toDataURL("image/jpeg", 0.5);
              const imgdata4 = document.getElementById("imagePreview4");
              html2canvas(imgdata4).then((canvas) => {
                imgdata[3] = canvas.toDataURL("image/jpeg", 0.5);
                const imgdata5 = document.getElementById("imagePreview5");
                html2canvas(imgdata5).then((canvas) => {
                  imgdata[4] = canvas.toDataURL("image/jpeg", 0.5);
                  const imgdata6 = document.getElementById("imagePreview6");
                  html2canvas(imgdata6).then((canvas) => {
                    imgdata[5] = canvas.toDataURL("image/jpeg", 0.5);
                    const imgdata7 = document.getElementById("imagePreview7");
                    html2canvas(imgdata7).then((canvas) => {
                      imgdata[6] = canvas.toDataURL("image/jpeg", 0.5);
                      const imgdata8 = document.getElementById("imagePreview8");
                      html2canvas(imgdata8).then((canvas) => {
                        imgdata[7] = canvas.toDataURL("image/jpeg", 0.5);
                        const imgdata9 =
                          document.getElementById("imagePreview9");
                        html2canvas(imgdata9).then((canvas) => {
                          imgdata[8] = canvas.toDataURL("image/jpeg", 0.5);
                          const imgdata10 =
                            document.getElementById("imagePreview10");
                          html2canvas(imgdata10).then((canvas) => {
                            imgdata[9] = canvas.toDataURL("image/jpeg", 0.5);
                            for (let i = 0; i < pagecount; i++) {
                              pdf.addImage(imgHeader, "JPEG", 0, 0);
                              pdf.addImage(imgdata[i], "JPEG", 25, 45);
                              pdf.addImage(imgFooter, "JPEG", 0, 275);
                              if (i !== pagecount - 1) {
                                pdf.addPage();
                              }
                            }

                            pdf.save("voucher.pdf");
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  };

  return (
    <div className={classes.div}>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={savepdf}
      >
        PDF
      </Button>

      <div>
        <FormGroup>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="pagecount">Page Count</InputLabel>
            <Select
              classname={classes.textField}
              labelId="pagecount"
              onChange={(e) => (pagecount = e.target.value)}
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={6}>6</MenuItem>
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={10}>10</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Channel">Channel</InputLabel>
            <Select
              classname={classes.textField}
              labelId="Channel"
              onChange={(e) => (x = e.target.value)}
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={6}>6</MenuItem>
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={8}>8</MenuItem>
              <MenuItem value={9}>9</MenuItem>
              <MenuItem value={10}>10</MenuItem>
            </Select>
          </FormControl>
        </FormGroup>
        <br></br>
        <div>
          <label for="myfile">Choose image:</label>
          <input
            type="file"
            name="myfile"
            id="myfile"
            width="200px"
            height="0px"
          ></input>
        </div>
        <br></br>
        <div id="image1">
          <p className={classes.para}>
            <b>Voucher Details: </b>
          </p>
          <img
            alt="Preview"
            id="imagePreview"
            width="600px"
            height="700px"
          ></img>
        </div>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 1</button>
        <br></br>
        <img
          alt="Preview2"
          id="imagePreview2"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 2</button>
        <br></br>
        <img
          alt="Preview3"
          id="imagePreview3"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 3</button>
        <br></br>
        <img
          alt="Preview4"
          id="imagePreview4"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 4</button>
        <br></br>
        <img
          alt="Preview5"
          id="imagePreview5"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 5</button>
        <br></br>
        <img
          alt="Preview6"
          id="imagePreview6"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 6</button>
        <br></br>
        <img
          alt="Preview7"
          id="imagePreview7"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 7</button>
        <br></br>
        <img
          alt="Preview8"
          id="imagePreview8"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 8</button>
        <br></br>
        <img
          alt="Preview9"
          id="imagePreview9"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 9</button>
        <br></br>
        <img
          alt="Preview10"
          id="imagePreview10"
          width="600px"
          height="700px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 10</button>
      </div>
      <div id="imgheader">
        <img
          onClick={() => console.log("abc")}
          src={header2}
          width="795"
          alt="quote header"
        ></img>
      </div>
      <div id="imgfooter">
          <Typography className={classes.texttypo2}>Refer a friend and share rewards up to Rs. 5000. <a href="https://www.jetovacations.com/quoterequest7?utm_source=doc&utm_medium=doc&utm_campaign=lead">Refer Now</a></Typography>
        <img src={footer2} width="795" alt="quote footer"></img>
      </div>
    </div>
  );
};

export default Viewvoucher;
